import {
  GET_TERM,
  GET_TERM_SUCCESS,
  GET_TERM_ERROR,
  DELETE_TERM,
  DELETE_TERM_SUCCESS,
  DELETE_TERM_ERROR
} from "../actions";

export const getTerm = (termId, activityInfo) => ({
  type: GET_TERM,
  payload: { termId, activityInfo },
});

export const getTermSuccess = (term) => ({
  type: GET_TERM_SUCCESS,
  payload: term,
});

export const getTermError = (message) => ({
  type: GET_TERM_ERROR,
  payload: { message },
});

export const trashTerm = (termId, activityInfo) => ({
  type: DELETE_TERM,
  payload: { termId, activityInfo },
});

export const trashTermSuccess = (successMessage) => ({
  type: DELETE_TERM_SUCCESS,
  payload: { successMessage },
});

export const trashTermError = (message) => ({
  type: DELETE_TERM_ERROR,
  payload: { message },
});